import React from "react"
import { Job, getJobId, JOB_ERROR_MAP } from "../../../data/job"

import moment from 'moment'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import defaultAudioImage1 from '../../../images/default-audio-image-1.jpg'
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { Link } from "react-router-dom"

const renderJobStatusIcon = (job: Job) => {
  let badgeColor: string, iconName: IconProp

  if (job.error === true) {
    badgeColor = 'danger'
    iconName = 'exclamation-triangle'
  } else if (job.finished_at) {
    badgeColor = 'success'
    iconName = 'check'
  } else {
    badgeColor = 'secondary'
    iconName = 'ellipsis-h'
  }

  return (
    <span className={`badge badge-${badgeColor}`}>
      <FontAwesomeIcon icon={iconName} />
    </span>
  )
}

const renderJobError: (job: Job) => (null | JSX.Element) = (job) => {
  if (job.error !== true) {
    return null
  }

  return <p className="card-text">
    { job.error_code ? (
      JOB_ERROR_MAP["en"][job.error_code]
    ) : (
      "An unexpected error occurred."
    ) }
  </p>
}

interface CardProps {
  job: Job
}

const Card: React.FC<CardProps> = ({job}) => {
  return <div className="col-12 col-sm-6 col-lg-3">
    <div className="card">
      <img className="card-img-top" src={defaultAudioImage1} alt="" />
      <div className="card-body">
        <h5 className="card-title">
          {renderJobStatusIcon(job)}
          &nbsp;
          {job.job_name}
        </h5>

        {renderJobError(job)}

        <Link className="btn btn-primary" to={`/transcript/jobs/${getJobId(job)}`}>Details</Link>
      </div>
      <div className="card-footer">
        <small className="text-muted">Submitted {moment(job.submitted_at).fromNow()}</small>
      </div>
    </div>
  </div>
}

export default Card
